"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/RLeapFROGS/RLeapFROGS/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var coreutils_1 = require("@phosphor/coreutils");

var widgets_1 = require("@phosphor/widgets");

var React = __importStar(require("react"));

var ReactDOM = __importStar(require("react-dom"));

var editor_1 = require("./editor");
/**
 * The class name added to a JSONEditor instance.
 */


var JSONEDITOR_CLASS = 'jp-JSONEditor';
/**
 * The class name added when the Metadata editor contains invalid JSON.
 */

var ERROR_CLASS = 'jp-mod-error';
/**
 * The class name added to the editor host node.
 */

var HOST_CLASS = 'jp-JSONEditor-host';
/**
 * The class name added to the header area.
 */

var HEADER_CLASS = 'jp-JSONEditor-header';
/**
 * The class name added to the title node.
 */

var TITLE_CLASS = 'jp-JSONEditor-title';
/**
 * The class name added to the collapser node.
 */

var COLLAPSER_CLASS = 'jp-JSONEditor-collapser';
/**
 * The class name added to the collapser node that is enabled.
 */

var COLLAPSE_ENABLED_CLASS = 'jp-mod-collapse-enabled';
/**
 * The class name added to the revert button.
 */

var REVERT_CLASS = 'jp-JSONEditor-revertButton';
/**
 * The class name added to the commit button.
 */

var COMMIT_CLASS = 'jp-JSONEditor-commitButton';
/**
 * The class name added to collapsed items.
 */

var COLLAPSED_CLASS = 'jp-mod-collapsed';
/**
 * A widget for editing observable JSON.
 */

var JSONEditor = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(JSONEditor, _widgets_1$Widget);

  var _super = _createSuper(JSONEditor);

  /**
   * Construct a new JSON editor.
   */
  function JSONEditor(options) {
    var _this;

    _classCallCheck(this, JSONEditor);

    _this = _super.call(this);
    _this._dataDirty = false;
    _this._inputDirty = false;
    _this._source = null;
    _this._originalValue = coreutils_1.JSONExt.emptyObject;
    _this._changeGuard = false;

    _this.addClass(JSONEDITOR_CLASS);

    ReactDOM.render(Private.createEditorContent(options), _this.node);
    var host = _this.editorHostNode;
    var model = new editor_1.CodeEditor.Model();
    model.value.text = 'No data!';
    model.mimeType = 'application/json';
    model.value.changed.connect(_this._onValueChanged, _assertThisInitialized(_this));
    _this.model = model;
    _this.editor = options.editorFactory({
      host: host,
      model: model
    });

    _this.editor.setOption('readOnly', true);

    _this.collapsible = !!options.collapsible;
    return _this;
  }
  /**
   * The title of the editor.
   */


  _createClass(JSONEditor, [{
    key: "editorTitle",
    get: function get() {
      return this.titleNode.textContent || '';
    },
    set: function set(value) {
      this.titleNode.textContent = value;
    }
    /**
     * Get the editor host node used by the JSON editor.
     */

  }, {
    key: "editorHostNode",
    get: function get() {
      return this.node.getElementsByClassName(HOST_CLASS)[0];
    }
    /**
     * Get the header node used by the JSON editor.
     */

  }, {
    key: "headerNode",
    get: function get() {
      return this.node.getElementsByClassName(HEADER_CLASS)[0];
    }
    /**
     * Get the title node used by the JSON editor.
     */

  }, {
    key: "titleNode",
    get: function get() {
      return this.node.getElementsByClassName(TITLE_CLASS)[0];
    }
    /**
     * Get the collapser node used by the JSON editor.
     */

  }, {
    key: "collapserNode",
    get: function get() {
      return this.node.getElementsByClassName(COLLAPSER_CLASS)[0];
    }
    /**
     * Get the revert button used by the JSON editor.
     */

  }, {
    key: "revertButtonNode",
    get: function get() {
      return this.node.getElementsByClassName(REVERT_CLASS)[0];
    }
    /**
     * Get the commit button used by the JSON editor.
     */

  }, {
    key: "commitButtonNode",
    get: function get() {
      return this.node.getElementsByClassName(COMMIT_CLASS)[0];
    }
    /**
     * The observable source.
     */

  }, {
    key: "source",
    get: function get() {
      return this._source;
    },
    set: function set(value) {
      if (this._source === value) {
        return;
      }

      if (this._source) {
        this._source.changed.disconnect(this._onSourceChanged, this);
      }

      this._source = value;
      this.editor.setOption('readOnly', value === null);

      if (value) {
        value.changed.connect(this._onSourceChanged, this);
      }

      this._setValue();
    }
    /**
     * Get whether the editor is dirty.
     */

  }, {
    key: "isDirty",
    get: function get() {
      return this._dataDirty || this._inputDirty;
    }
    /**
     * Handle the DOM events for the widget.
     *
     * @param event - The DOM event sent to the widget.
     *
     * #### Notes
     * This method implements the DOM `EventListener` interface and is
     * called in response to events on the notebook panel's node. It should
     * not be called directly by user code.
     */

  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      switch (event.type) {
        case 'blur':
          this._evtBlur(event);

          break;

        case 'click':
          this._evtClick(event);

          break;

        default:
          break;
      }
    }
    /**
     * Handle `after-attach` messages for the widget.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      var node = this.editorHostNode;
      node.addEventListener('blur', this, true);
      node.addEventListener('click', this, true);
      this.revertButtonNode.hidden = true;
      this.commitButtonNode.hidden = true;
      this.headerNode.addEventListener('click', this);

      if (this.isVisible) {
        this.update();
      }
    }
    /**
     * Handle `after-show` messages for the widget.
     */

  }, {
    key: "onAfterShow",
    value: function onAfterShow(msg) {
      this.update();
    }
    /**
     * Handle `update-request` messages for the widget.
     */

  }, {
    key: "onUpdateRequest",
    value: function onUpdateRequest(msg) {
      this.editor.refresh();
    }
    /**
     * Handle `before-detach` messages for the widget.
     */

  }, {
    key: "onBeforeDetach",
    value: function onBeforeDetach(msg) {
      var node = this.editorHostNode;
      node.removeEventListener('blur', this, true);
      node.removeEventListener('click', this, true);
      this.headerNode.removeEventListener('click', this);
    }
    /**
     * Handle a change to the metadata of the source.
     */

  }, {
    key: "_onSourceChanged",
    value: function _onSourceChanged(sender, args) {
      if (this._changeGuard) {
        return;
      }

      if (this._inputDirty || this.editor.hasFocus()) {
        this._dataDirty = true;
        return;
      }

      this._setValue();
    }
    /**
     * Handle change events.
     */

  }, {
    key: "_onValueChanged",
    value: function _onValueChanged() {
      var valid = true;

      try {
        var value = JSON.parse(this.editor.model.value.text);
        this.removeClass(ERROR_CLASS);
        this._inputDirty = !this._changeGuard && !coreutils_1.JSONExt.deepEqual(value, this._originalValue);
      } catch (err) {
        this.addClass(ERROR_CLASS);
        this._inputDirty = true;
        valid = false;
      }

      this.revertButtonNode.hidden = !this._inputDirty;
      this.commitButtonNode.hidden = !valid || !this._inputDirty;
    }
    /**
     * Handle blur events for the text area.
     */

  }, {
    key: "_evtBlur",
    value: function _evtBlur(event) {
      // Update the metadata if necessary.
      if (!this._inputDirty && this._dataDirty) {
        this._setValue();
      }
    }
    /**
     * Handle click events for the buttons.
     */

  }, {
    key: "_evtClick",
    value: function _evtClick(event) {
      var target = event.target;

      switch (target) {
        case this.revertButtonNode:
          this._setValue();

          break;

        case this.commitButtonNode:
          if (!this.commitButtonNode.hidden && !this.hasClass(ERROR_CLASS)) {
            this._changeGuard = true;

            this._mergeContent();

            this._changeGuard = false;

            this._setValue();
          }

          break;

        case this.titleNode:
        case this.collapserNode:
          if (this.collapsible) {
            var collapser = this.collapserNode;

            if (collapser.classList.contains(COLLAPSED_CLASS)) {
              collapser.classList.remove(COLLAPSED_CLASS);
              this.editorHostNode.classList.remove(COLLAPSED_CLASS);
            } else {
              collapser.classList.add(COLLAPSED_CLASS);
              this.editorHostNode.classList.add(COLLAPSED_CLASS);
            }
          }

          break;

        case this.editorHostNode:
          this.editor.focus();
          break;

        default:
          break;
      }
    }
    /**
     * Merge the user content.
     */

  }, {
    key: "_mergeContent",
    value: function _mergeContent() {
      var model = this.editor.model;
      var current = this._source ? this._source.toJSON() : {};
      var old = this._originalValue;
      var user = JSON.parse(model.value.text);
      var source = this.source;

      if (!source) {
        return;
      } // If it is in user and has changed from old, set in current.


      for (var key in user) {
        if (!coreutils_1.JSONExt.deepEqual(user[key], old[key] || null)) {
          current[key] = user[key];
        }
      } // If it was in old and is not in user, remove from current.


      for (var _key in old) {
        if (!(_key in user)) {
          delete current[_key];
          source.delete(_key);
        }
      } // Set the values.


      for (var _key2 in current) {
        source.set(_key2, current[_key2]);
      }
    }
    /**
     * Set the value given the owner contents.
     */

  }, {
    key: "_setValue",
    value: function _setValue() {
      this._dataDirty = false;
      this._inputDirty = false;
      this.revertButtonNode.hidden = true;
      this.commitButtonNode.hidden = true;
      this.removeClass(ERROR_CLASS);
      var model = this.editor.model;
      var content = this._source ? this._source.toJSON() : {};
      this._changeGuard = true;

      if (content === void 0) {
        model.value.text = 'No data!';
        this._originalValue = coreutils_1.JSONExt.emptyObject;
      } else {
        var value = JSON.stringify(content, null, 4);
        model.value.text = value;
        this._originalValue = content; // Move the cursor to within the brace.

        if (value.length > 1 && value[0] === '{') {
          this.editor.setCursorPosition({
            line: 0,
            column: 1
          });
        }
      }

      this.editor.refresh();
      this._changeGuard = false;
      this.commitButtonNode.hidden = true;
      this.revertButtonNode.hidden = true;
    }
  }]);

  return JSONEditor;
}(widgets_1.Widget);

exports.JSONEditor = JSONEditor;
/**
 * The namespace for module private data.
 */

var Private;

(function (Private) {
  /**
   * Create the JSON Editor node's content.
   */
  function createEditorContent(options) {
    var revertTitle = 'Revert changes to data';
    var confirmTitle = 'Commit changes to data';
    var title = options.title || '';
    var collapseClass = options.collapsible ? "".concat(COLLAPSER_CLASS, " ").concat(COLLAPSE_ENABLED_CLASS) : COLLAPSER_CLASS;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: HEADER_CLASS
    }, React.createElement("span", {
      className: TITLE_CLASS
    }, title), React.createElement("span", {
      className: collapseClass
    }), React.createElement("span", {
      className: REVERT_CLASS,
      title: revertTitle
    }), React.createElement("span", {
      className: COMMIT_CLASS,
      title: confirmTitle
    })), React.createElement("div", {
      className: HOST_CLASS
    }));
  }

  Private.createEditorContent = createEditorContent;
})(Private || (Private = {}));